const VERIFY_ACCOUNT_NUMBER = "/common/account/name-enquiry";
const GET_CUSTOMER_INFORMATION = "/common/account/card-account-detail";

export const ACCOUNT_ENQUIRY_ROUTES = {
  VERIFY_ACCOUNT_NUMBER,
  GET_CUSTOMER_INFORMATION,
};
